import { render, staticRenderFns } from "./EntityEvohealthHealthGroups.vue?vue&type=template&id=6a6a985a&scoped=true"
import script from "./EntityEvohealthHealthGroups.vue?vue&type=script&lang=js"
export * from "./EntityEvohealthHealthGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6a985a",
  null
  
)

export default component.exports